var _rect, _rect2, _rect3, _rect4, _line, _line2, _line3, _line4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaterials(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 70.9302,
    width: 26.5957,
    height: 29.0698,
    rx: 3,
    fill: "#F7931E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 73.4043,
    y: 70.9302,
    width: 26.5957,
    height: 29.0698,
    rx: 3,
    fill: "#F7931E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 73.4043,
    width: 26.5957,
    height: 29.0698,
    rx: 3,
    fill: "#F7931E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 26.5957,
    height: 29.0698,
    rx: 3,
    fill: "#F7931E"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 12.5,
    y1: 29,
    x2: 12.5,
    y2: 70.8605,
    stroke: "#29ABE2",
    strokeWidth: 7
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 27,
    y1: 15.5,
    x2: 73.8085,
    y2: 15.5,
    stroke: "#29ABE2",
    strokeWidth: 7
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 27,
    y1: 87.5,
    x2: 73.8085,
    y2: 87.5,
    stroke: "#29ABE2",
    strokeWidth: 7
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 87.5,
    y1: 29,
    x2: 87.5,
    y2: 70.8605,
    stroke: "#29ABE2",
    strokeWidth: 7
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterials);
export default __webpack_public_path__ + "static/media/Materials.22b4585c358aba486dd54c81089c1afd.svg";
export { ForwardRef as ReactComponent };